import React, { useState } from 'react';
import Swal from 'sweetalert2';
import clinicService from '../../../../../services/clinic.service';
import 'bootstrap-icons/font/bootstrap-icons.css';

function MediaListItem({ item, updateMediaList }) {
    const [isCopied, setIsCopied] = useState(false);

    const handleDelete = () => {
        Swal.fire({
            title: 'Delete Media?',
            html: `<div class="text-center small">
                     <i class="bi bi-trash3-fill text-danger fs-1 mb-3"></i>
                     <p class="small">Are you sure you want to delete <strong>${item.name}</strong>?</p>
                   </div>`,
            showCancelButton: true,
            confirmButtonText: `
            <i class="bi bi-check"></i>
            Yes, delete it!`,
            cancelButtonText: `
            <i class="bi bi-x"></i>
            Cancel`,
            customClass: {
                title: 'card-title',
                confirmButton: 'btn btn-danger btn-sm me-2',
                cancelButton: 'btn btn-secondary btn-sm'
            },
            buttonsStyling: false,
            showLoaderOnConfirm: true,
            preConfirm: () => {
                return clinicService.deleteMedia(item.clinicId, [item.id])
                    .then(() => true)
                    .catch(error => {
                        Swal.showValidationMessage(`Delete failed: ${error.message}`);
                    });
            }
        }).then((result) => {
            if (result.isConfirmed) {
                updateMediaList();
            }
        });
    };

    const handleCopy = async (textToCopy) => {
        try {
            await navigator.clipboard.writeText(textToCopy);
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000);
        } catch (error) {
            console.error('Failed to copy:', error);
            // Fallback method
            const textArea = document.createElement('textarea');
            textArea.value = textToCopy;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000);
        }
    };

    const formatFileSize = (bytes) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
    };

    return (
        <div className="card card-border shadow-none card-padding">
            <div className="card-body p-3 d-flex flex-column">
                {/* Thumbnail at top */}
                <div
                    className="text-center mb-3 position-relative rounded overflow-hidden"
                    style={{
                        width: '100%',
                        height: '160px',
                        backgroundColor: '#f8f9fa'
                    }}
                >
                    <img
                        src={item.path}
                        alt={item.name}
                        className="h-100 w-100"
                        style={{
                            objectFit: 'contain',
                            mixBlendMode: item.type.includes('png') ? 'normal' : 'initial'
                        }}
                        loading="lazy"
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = '/path/to/fallback-image.png';
                        }}
                    />
                </div>

                {/* File info */}
                <div className="mb-2">
                    <h6 className="card-title mb-1 text-truncate">{item.name}</h6>
                    <div className="d-flex justify-content-center align-items-center">
                    <div className="d-flex flex-wrap gap-2 mb-2">
                        <small className="text-muted">
                            <i className="bi bi-calendar me-1"></i>
                            {item.modifiedAt}
                        </small>
                        <small className="text-muted badge status-incomplete text-danger">
                            <i className="bi bi-file-earmark me-1"></i>
                            {item.type}
                        </small>
                        <small className="text-muted badge status-completed text-success">
                            <i className="bi bi-hdd me-1"></i>
                            {formatFileSize(item.sizeBytes)}
                        </small>
                    </div>
                    <div className="d-flex justify-content-end">
                        <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={handleDelete}
                        >
                            <i className="bi bi-trash"></i>
                        </button>
                    </div>
                    </div>
                </div>

                {/* Path and actions */}
                <div className="mt-auto">
                    <div className="input-group input-group-sm mb-2">
                        <input
                            type="text"
                            className="form-control form-control-sm bg-light"
                            value={item.path}
                            readOnly
                            disabled
                        />
                        <button
                            className="btn btn-outline-secondary"
                            type="button"
                            onClick={() => handleCopy(item.path)}
                            disabled={isCopied}
                        >
                            {isCopied ? (
                                <i className="bi bi-check2 text-success"></i>
                            ) : (
                                <i className="bi bi-copy"></i>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MediaListItem;